module.exports = __webpack_public_path__ + "static/media/cricket-icon.d94c3229.svg";